import * as React from 'react';

import {StatsBlockVertical} from 'shells/metrics/stats-block-vertical';
import {Percentage} from 'shells/percentage/percentage';

import styles from './form-engagement-bar.module.css';

type Props = {
    pageVisits: number;
    numSubmissions: number;
    conversionRate: number;
};

export function FormEngagementBar(props: Props) {
    const {pageVisits, numSubmissions, conversionRate} = props;

    return (
        <div className={styles['form-stats']}>
            <StatsBlockVertical
                hasBorders={false}
                stats={[
                    {
                        key: '1',
                        // @ts-expect-error
                        title: 'Page visits',
                        value: pageVisits.toLocaleString(),
                        secondaryValue: undefined,
                    },
                    {
                        key: '2',
                        // @ts-expect-error
                        title: 'Form submissions',
                        value: numSubmissions.toLocaleString(),
                        secondaryValue: undefined,
                    },
                    {
                        key: '3',
                        // @ts-expect-error
                        title: 'Conversion rate',
                        // @ts-expect-error
                        value: <Percentage value={conversionRate} precision={2} />,
                        secondaryValue: undefined,
                    },
                ]}
            />
        </div>
    );
}
